import { type FC } from 'react'
import classNames from 'classnames'
import styles from './Tags.module.scss'

interface FilterChipProps {
  pressed: boolean
  label: string
  icon?: string
  count?: number
  onClick: () => void
}

export const FilterChip: FC<FilterChipProps> = ({ pressed, label, icon, count, onClick }) => {
  return (
    <button
      type='button'
      aria-pressed={pressed}
      className={classNames('d-inline-flex align-items-center gap-1 px-2 py-1 rounded-1 paragraph-small border bg-white', styles.chipInteractive, {
        'zocks-border-color-primary zocks-text-primary': pressed,
        'zocks-border-color-gray-200 zocks-text-gray-600': !pressed,
      })}
      onClick={onClick}
    >
      {icon ? <i className={classNames('bi', icon)} aria-hidden='true' /> : null}
      {label}
      {count === undefined ? null : <span className='zocks-text-gray-500'>{count}</span>}
    </button>
  )
}
